import React from "react";
import { Tabs } from "antd";
import FactoryBankAccountModal from "../../components/setting-conponents/Factory/FactoryBankAccountModal";
import FactoryGeneralModal from "../../components/setting-conponents/Factory/FactoryGeneralModal";
import FactoryBankAccountList from "../../components/setting-conponents/Factory/FactoryBankAccountList";
import FactoryGeneralLIst from "../../components/setting-conponents/Factory/FactoryGeneralLIst";
import { useUserContext } from "../../hooks/UserSettingProvider";
import { USER_GROUP } from "../../constants/string";

export default function FactorySettingsView() {
  const [activeTab, setActiveTab] = React.useState("");

  const [openFactoryBankAccountList, setOpenFactoryBankAccountList] = React.useState(false);
  const [openFactoryGeneralList, setOpenFactoryGeneralList] = React.useState(false);

  const { user } = useUserContext();
  const hasPermission = (target) => (user && user.groups &&  user.groups.length > 0 ? (user.groups.find((group) => group === target) ? true : false) : true)

  const tableRef = React.useRef(null);

  const items = [
    {
      key: "FactoryGeneral",
      label: "ข้อมูลทั่วไป",
      children: <FactoryGeneralLIst isDone={false} ref={tableRef} />,
      permissions : hasPermission(USER_GROUP.MANAGER)
    },
    {
      key: "FactoryBankAccount",
      label: "บัญชีธนาคาร",
      children: <FactoryBankAccountList isDone={false} ref={tableRef} />,
      permissions : (hasPermission(USER_GROUP.MANAGER) || hasPermission(USER_GROUP.WT_LATEX))
    },
  ];

  const refreshData = async () => {
    if (tableRef.current) {
      await tableRef.current.fetchTable();
    }
  };


  React.useEffect(() => {
    const defaultActiveTabs = items.find((item) => item.permissions == true) ? items.find((item) => item.permissions == true).key : '' ;
    setActiveTab(defaultActiveTabs)
  },[])

  return (
    <div style={{ marginTop: 20 }}>
      <Tabs
        destroyInactiveTabPane
        activeKey={activeTab}
        onChange={setActiveTab}
        items={items.filter((item) => item.permissions == true)}
        style={{ marginTop: 15 }}
      />
      <FactoryBankAccountModal 
        open={openFactoryBankAccountList}
        onClose={() => setOpenFactoryBankAccountList(false)}
        onUpdate={() => {
          setOpenFactoryBankAccountList(false);
          refreshData();
        }}
        target={null}
      />
      <FactoryGeneralModal
        open={openFactoryGeneralList}
        onClose={() => setOpenFactoryGeneralList(false)}
        onUpdate={() => {
          setOpenFactoryGeneralList(false);
          refreshData();
        }}
        target={null}
      />
    </div>
  );
}
